import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { MyClientPageSection } from '../../components/my-client-section.component';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './../../scss/components/manage-invoice.style.scss';
// import { useMediaQuery } from '@mui/material';

/* Tiny sparkles icon for the hero badge. Inline so the page has no
   new icon-library dependency. */
const HeroSparkles = () => (
    <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .962 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.962 0z" />
        <path d="M20 3v4" /><path d="M22 5h-4" /><path d="M4 17v2" /><path d="M5 18H3" />
    </svg>
);

/* Render the title with the LAST word styled as a violet gradient brand
   accent — works for any locale ("My customers" → "My **customers**",
   "Mina kunder" → "Mina **kunder**"). Single-word titles are fully
   gradient-styled. */
const renderHeroTitle = (title: string) => {
    const trimmed = (title || '').trim();
    if (!trimmed) return null;
    const idx = trimmed.lastIndexOf(' ');
    if (idx === -1) {
        return <span className="mi-hero__brand">{trimmed}</span>;
    }
    const prefix = trimmed.slice(0, idx);
    const last = trimmed.slice(idx + 1);
    return (
        <>
            {prefix}{' '}
            <span className="mi-hero__brand">{last}</span>
        </>
    );
};

const MyClientPage = ({
}) => {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='clients'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                {isSidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}

                <div className="dashboard-main-content ">
                    <Header
                    setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className="manage-invoice-v2">
                        {/* Hero header — soft violet glassy card mirroring the
                            Contract Center hero, scoped to this page only via
                            the .mi-hero class (no other pages affected). */}
                        <div className="mi-hero">
                            {/* Page wording uses "Clients" via dedicated keys
                                (CLIENT_CENTER / MY_CLIENTS_HERO_TITLE /
                                MY_CLIENTS_HERO_SUBTITLE) so the existing
                                MY_CLIENTS / CUSTOMER_CENTER / MY_CLIENTS_SUBTITLE
                                values — used by the sidebar nav, the section
                                component and any other consumer — keep saying
                                "Customers" and aren't affected. */}
                            <span className="mi-hero__badge">
                                <HeroSparkles />
                                {t('CLIENT_CENTER', { defaultValue: 'Client Center' })}
                            </span>
                            <h1 className="mi-hero__title">
                                {renderHeroTitle(t('MY_CLIENTS_HERO_TITLE', { defaultValue: 'My Clients' }))}
                            </h1>
                            <p className="mi-hero__subtitle">
                                {t('MY_CLIENTS_HERO_SUBTITLE', { defaultValue: 'On this page, you can add new clients, edit and update existing client details, delete any client when needed, and create a new invoice for any selected client with just one click.' })}
                            </p>
                        </div>
                        <div className="manage-invoice-v2__panel">
                            <MyClientPageSection className="invoices-section my-clients-table" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default MyClientPage;